import * as SC from "../../styles/styles";

import React from "react";

export const Catalogo = () => {
  return (
    <>
      <SC.AboutContainer>
        <SC.ProductSpaceContainer>
          <SC.Text1>Catálogo</SC.Text1>
        </SC.ProductSpaceContainer>
      </SC.AboutContainer>
      <SC.ListWhite>
        <SC.TextListHolder>
          <SC.Text3>Controle e gestão de acesso</SC.Text3>
          <SC.TextP>
            &emsp;&emsp;&emsp;Defina restrições de segurança quanto à senha
            definida pelo usuário, a partir de uma interface que permite criar,
            editar e remover usuários e perfis de acesso. Além disso, é possível
            habilitar a função de duplo fator de autenticação de senha de acesso
            à plataforma.
          </SC.TextP>
        </SC.TextListHolder>
        <SC.TextListHolder>
          <SC.Text3>Cadastro de equipes e funcionários</SC.Text3>
          <SC.TextP>
            &emsp;&emsp;&emsp;Cadastre e gerencie empresas, usuários e equipes
            envolvidas na manutenção, e os membros que a compõem. Consulte a
            composição da equipe (funcionários alocados) a partir de uma data,
            possibilitando que os gestores verifiquem quem eram os funcionários
            alocados na equipe no momento que realizaram os atendimentos.
          </SC.TextP>
        </SC.TextListHolder>
        <SC.TextListHolder>
          <SC.Text3>Plataforma de mapeamento e georreferenciamento</SC.Text3>
          <SC.TextP>
            &emsp;&emsp;&emsp;O Mapeamento e o Georreferenciamento possibilitam
            a visualização das outras bases georreferenciadas do município
            simultaneamente com a base de iluminação pública, visualizando
            camadas disponibilizadas em formato WMS (“Web Map Service”), e
            permitindo a importação de arquivos shapefile fornecidos pela
            Prefeitura.
            <br />
            &emsp;&emsp;&emsp;Visualize em tempo real de todos os pontos do
            município com alto desempenho, incluindo a exibição dinâmica de
            veículos e aparelhos conectados, a visualização das ocorrências, os
            atendimentos e as ordens de serviço diretamente sobre o mapa. Todas
            as informações são atualizadas automaticamente conforme as operações
            evoluem, possibilitanto o acompanhamento em tempo real das
            atividades e facilitando a gestão das equipes e recursos no
            território.
          </SC.TextP>
        </SC.TextListHolder>
        <SC.TextListHolder>
          <SC.Text3>Gestão de pontos de serviço</SC.Text3>
          <SC.TextTopic>Módulo de cadastro</SC.TextTopic>
          <SC.TextP>
            &emsp;&emsp;&emsp;O módulo pode ser acessado via Web, através de um
            navegador, e de forma móvel que opera em dispositivos portáteis
            (tablets e smartphones) que operam em sistemas iOS e Android.
            Permite adicionar, remover e editar pontos de iluminação ou qualquer
            tipo de equipamento.
            <br />
            &emsp;&emsp;&emsp;Individualmente cada ponto possui: sua respectiva
            posição no mapa (coordenadas geográficas, os dados de endereçamento
            (município, logradouro, número e referências), seu número de
            etiqueta de identificação patrimonial, identificação visual (fotos
            e/ou vídeos), quaisquer dados definidos pelo gestor na forma de
            atributos parametrizáveis, relação de materiais instalados de acordo
            com o cadastro de materiais. <br />
            &emsp;&emsp;&emsp;Possui também o cadastro de ativos do tipo
            árvores, quadros de comandos, medidores e etc. Os mesmos, vinculam
            as coordenadas georreferenciadas com ícones representativos, além de
            exibir de forma inteligente: o mapeamento com as suas fotos,
            características físicas, a vida útil dos materiais e os dispositivos
            de telegestão.
          </SC.TextP>
          <SC.TextTopic>Relatórios</SC.TextTopic>
          <SC.TextP>
            &emsp;&emsp;&emsp;O sistema fornece um relatório interativo que
            permite que, o usuário visualize em um mapa os pontos de iluminação
            existentes com números das etiquetas dos pontos, quando existentes,
            diferenciando por cores os tipos e potências de lâmpadas. No quesito
            interatividade, ao clicar sobre um ponto de iluminação posicionado
            no mapa, podemos visualizar as seguintes informações: número da
            etiqueta, endereço, atributos e materiais incluídos no ponto.
          </SC.TextP>
        </SC.TextListHolder>
        <SC.TextListHolder>
          <SC.Text3>Gestão de solicitações</SC.Text3>
          <SC.TextP>
            &emsp;&emsp;&emsp;Pela Web, os agentes de teleatendimento e usuários
            da Prefeitura podem acessar a plataforma permitindo, o registro, o
            acompanhamento e o despacho das solicitações realizadas pelos
            munícipes. Possibilitando a busca de logradouros a partir da base
            importada dos Correios e/ou diretamente pesquisando no mapa viário
            da cidade, garantindo o georreferenciamento preciso do local da
            solicitação, mesmo em áreas cujos pontos de iluminação ainda não
            tenham sido cadastrados.
            <br />
            &emsp;&emsp;&emsp;Ao registrar uma solicitação, é possível cadastrar
            o munícipe, armazenando dados de forma segura para atendimentos
            futuros. O sistema também possibilita que o cidadão realize
            solicitações de reparo por meio de aplicativos de mensagem
            instantânea como WhatsApp, a partir de suas informações de contato,
            tipo de problema e localização georreferenciada com confirmação no
            mapa e recebendo automaticamente um protocolo de atendimento. Essas
            solicitações são processadas de forma automatizada, sem a
            necessidade de intervenção humana, salvo quando solicitado pelo
            próprio munícipe, visando reduzir custos e aumentar a eficiência
            operacional.
            <br />
            &emsp;&emsp;&emsp;O módulo de serviços permite que os gestores
            acompanhem em tempo real todas as solicitações registradas. Além de
            exibir informações como: o número e o percentual de solicitações
            despachadas para as equipes de campo, gráficos percentuais por tipo
            e prioridade das solicitações em aberto e a relação das solicitações
            atendidas ou pendentes, sendo possível cadastrar alertas automáticos
            para ocorrências com prazos vencidos ou a vencer.
            <br />
            &emsp;&emsp;&emsp;O despacho das solicitações permite o envio direto
            das ocorrências para as equipes de campo, gerando ordens de serviço
            vinculadas. O gestor tem opções de filtros como: solicitações por
            região, bairro, tipo de problema, prioridade ou especialidade da
            equipe responsável. A busca geográfica no mapa da cidade, outra
            possibilidade disponível, localiza as coordenadas dos endereços das
            solicitações, mesmo quando não identificados previamente pelos
            atendentes.
            <br />
            &emsp;&emsp;&emsp;O sistema adota o conceito de microárea, que
            permite agrupar automaticamente as ordens de serviço em lotes
            geográficos pré-determinados, otimizando o deslocamento das equipes
            e reduzindo custos com combustível. O despacho permite o agrupamento
            e desagrupamento manual das ocorrências, a definição de raios de
            agrupamento automáticos, e a geração de rotas otimizadas para o
            atendimento para serem visualizadas pelo aplicativo operacional.
            Além disso, é possível encaminhar solicitações para departamentos
            específicos, cancelar, reprogramar ou indeferir de solicitações, com
            registro do motivo e prazo de execução, garantindo rastreabilidade e
            controle total sobre o fluxo de atendimento.
          </SC.TextP>
        </SC.TextListHolder>
        <SC.TextListHolder>
          <SC.Text3>Portal de internet</SC.Text3>
          <SC.TextP>
            &emsp;&emsp;&emsp;O portal de Internet permite que munícipes
            cadastrem solicitações de Iluminação Pública de forma totalmente
            integrada, dispensando assim a necessidade de importação ou
            exportação de dados. (O portal pode ser disponibilizado dentro do
            propio site da prefeitura, caso solicitado).
            <br />
            &emsp;&emsp;&emsp;Com um simples pré-cadastro composto de: nome
            completo, telefone, e-mail e CPF, o municípe pode consultar seus
            protocolos e abrir novas solicitações. Na busca do logradouro para
            registrar solicitações, os dados são validados no mapa a fim de
            evitar erros de endereçamento.
          </SC.TextP>
        </SC.TextListHolder>
        <SC.TextListHolder>
          <SC.Text3>
            Chatbot automatizado no WhatsApp para atendimento ao cidadão
          </SC.Text3>
          <SC.TextP>
            &emsp;&emsp;&emsp;O sistema dispõe de um Chatbot automatizado no
            WhatsApp com integração plena ao sistema de gestão do parque, edite
            e configure o fluxo conversacional para melhor atender o escopo, com
            opções como: editar dados solicitados para o cidadão e os problemas
            encontrados nos postes de iluminação. Além de opções de cadastro
            pelo número da plaqueta, disponibilizando um link do Google Maps
            para exibir a localização do ponto a partir do endereço, e
            acrescentar observações para facilitar o atendimento. Ao final do
            atendimento, um protocolo único é informado, e pode ser usado para
            consultar informações referentes a solicitação.
          </SC.TextP>
        </SC.TextListHolder>
        <SC.TextListHolder>
          <SC.Text3>Aplicativo para o cidadão</SC.Text3>
          <SC.TextP>
            &emsp;&emsp;&emsp;Dispomos de uma gama variada de aplicativos de
            distribuição pública e coorporativa com múltiplos níveis de acesso.
            Disponibilizados no canais de seus respctivos sistemas, as lojas
            oficiais do android e iOS.
            <br />
            &emsp;&emsp;&emsp;O aplicativo exclusivo para o município é capaz de
            registrar solicitações através da busca por logradouro ou da
            etiqueta, além de permitir a troca de mensagens com o operador de
            campo para melhor localização dos problemas.
            <br />
            &emsp;&emsp;&emsp;Integração direta com as contas oficiais do
            Instagram da contratante e exibição internas das publicações e
            stories dentro do aplicativo.
          </SC.TextP>
        </SC.TextListHolder>
        <SC.TextListHolder>
          <SC.Text3>Aplicativo móvel para as equipes de campo</SC.Text3>
          <SC.TextP>
            &emsp;&emsp;&emsp;O aplicativo não necessita de conexão constante
            com a internet, permitindo o uso das funções mesmo em áreas sem
            cobertura de rede no modo offline. Com ele podemos visualizar as
            ordens de serviço despachadas para a equipe, os dados das
            solicitações relacionadas e as informações dos reclamantes que
            geraram as ocorrências.
            <br />
            &emsp;&emsp;&emsp;Com a coleta precisa de dados de campo, incluindo
            coordenadas geográficas e horários de início e término de cada
            serviço obtidos por satélite GPS, é possível assegurar a integridade
            e a precisão temporal. Permite registrar com fotos, cada atendimento
            antes e depois da sua execução, sem limite de fotos por ponto e com
            registro automático de data, hora e localização. Os dados
            registrados aguardam a conexão com a internet para sincroniza-los.
          </SC.TextP>
        </SC.TextListHolder>
        <SC.TextListHolder>
          <SC.Text3>Parametrização dos prazos de atendimento</SC.Text3>
          <SC.TextP>
            &emsp;&emsp;&emsp;Possibilita que sejam definidos prazos de
            atendimento por tipo de solicitação em dias ou horas. Cadastrando
            prazos de atendimento diferenciados de acordo com a prioridade de
            atendimento e os contratos de serviço em vigor. Poderá também
            configurar os parâmetros de manutenção preditiva, preventiva,
            corretiva e emergencial.
          </SC.TextP>
        </SC.TextListHolder>
        <SC.TextListHolder>
          <SC.Text3>Gestão de manutenção</SC.Text3>
          <SC.TextP>
            &emsp;&emsp;&emsp;Registre e o acompanhe os serviços realizados em
            campo, controlando de forma completa: as ordens de serviço,
            acompanhamento de status, histórico de execução, custos, tempo de
            atendimento e equipe responsável por cada manutenção. Acompanhe os
            serviços realizados através de relatórios detalhados e exporte a
            base completa de serviços, garantindo a rastreabilidade e a
            transparência das atividades executadas.
            <br />
            &emsp;&emsp;&emsp;Com isso, permite a consulta dos motivos das
            solicitações, dos problemas encontrados e das soluções aplicadas,
            assegurando uma gestão eficiente das ocorrências e manutenções
            realizadas.
          </SC.TextP>
        </SC.TextListHolder>
        <SC.TextListHolder>
          <SC.Text3>Controle de estoque de materiais</SC.Text3>
          <SC.TextP>
            &emsp;&emsp;&emsp;Os materiais aplicados são informados para
            garantir a correta gestão dos estoques dos veículos e a garantia dos
            materiais, além dos serviços executados que não envolvem troca de
            materiais. Verificando também os itens retirados que estão em
            garantia, ou os itens que serão descartados como sucata, a partir de
            centros de estoque específicos que controlam os itens.
            <br />
            &emsp;&emsp;&emsp;Gerencie centros de estoque por equipe e/ou ou
            veículos que capacita o gestor com visualizações quantitativas de
            materiais em posse de cada equipe/veículo, realçando os materiais
            novos, usados e retirados que estão pendentes de entrega. O módulo
            de estoque permite também controlar de forma plena as movimentações,
            cadastros, liberações separações e confirmações de transferências.
            (a depender do nível de acesso que o usuário possui).
            <br />
            &emsp;&emsp;&emsp;Além de permitir o controle de materiais em
            garantia e sucata, registro de composições de materiais e integração
            com os aplicativos de campo com atualizações em tempo real.
          </SC.TextP>
        </SC.TextListHolder>
        <SC.TextListHolder>
          <SC.Text3>Cadastro de obras</SC.Text3>
          <SC.TextP>
            &emsp;&emsp;&emsp;Cadastre projetos, obras de ampliação e melhorias,
            utilizando dados básicos de identificação como requisito mínimo:
            tipo da obra, localização, responsável, prazo de execução,
            descrição, datas de início e término.
          </SC.TextP>
        </SC.TextListHolder>
        <SC.TextListHolder>
          <SC.Text3>Relatórios</SC.Text3>
          <SC.TextP>
            &emsp;&emsp;&emsp;O módulo de relatórios operacionais, permite o
            acompanhamento detalhado de todas as informações relacionadas à
            gestão da iluminação pública. Além de possibilitar a geração de
            relatórios com listagem dos pontos cadastrados no sistema e a
            exportação dos dados para planilhas no formato Excel e PDF. Exibe
            relatórios interativos em mapa, com distinção visual utilizando
            realce de cores e tipos de lâmpadas. Os itens interativos respondem
            ao clicque sobre o ponto exibido no mapa, onde são apresentados as
            informações de número da etiqueta, endereço, atributos associados e
            materiais instalados.
            <br />
            &emsp;&emsp;&emsp;Gere relatórios patrimoniais customizáveis de
            acordo com as necessidades da Prefeitura, que identificam
            percentuais de pontos que possuem determinadas características como
            tipo ou potência de lâmpada. Gere também relatórios de
            produtividade, incluindo o número e percentual de solicitações
            despachadas para as equipes de campo, gráficos percentuais por tipo
            e prioridade das solicitações abertas, além da relação das
            solicitações atendidas e não atendidas, com emissão de alertas
            automáticos para aquelas com prazo vencido ou a vencer.
            <br />
            &emsp;&emsp;&emsp;Explore gerar relatórios com o número de pontos
            cadastrados por mês ou semana e por equipe, bem como acompanhar a
            gestão dos materiais aplicados e retirados em campo, mantendo um
            histórico completo de estoque e consumo. Além de visualizar a
            produtividade das equipes por quantidade de atendimentos realizados
            em determinado período e exibir indicadores de desempenho por
            equipe, bairro e tipo de serviço.
            <br />
            &emsp;&emsp;&emsp;Os relatórios são compostos com informações sobre
            os estágios dos chamados por data de vencimento, reincidência de
            reclamações por localidade, quantidade diária de chamados, taxa de
            falha por tipo de material, evolução mensal do consumo de energia e
            total de atendimentos realizados por equipe em períodos específicos,
            número de manutenções realizadas dentro e fora do prazo contratual,
            gráficos de proporção mensal e comparativos de eficiência com base
            no tempo médio de atendimento.
            <br />
            &emsp;&emsp;&emsp;Além disso, todos os relatórios estão disponíveis
            para exportação em formatos XLS e PDF, garantindo facilidade de
            compartilhamento e análise dos dados gerenciais e operacionais do
            sistema.
          </SC.TextP>
        </SC.TextListHolder>
        <SC.TextListHolder>
          <SC.Text3>Gestão remota das luminárias</SC.Text3>
          <SC.TextP>
            &emsp;&emsp;&emsp;Visualize os principais indicadores e o
            acionamento remoto de diversas funções, dentre elas, podemos
            destacar:
          </SC.TextP>
          <SC.TextList>
            <li>
              Identificação visual da quantidade de luminárias em funcionamento
              e com defeitos/falhas de funcionamento;
            </li>
            <li>
              Exibir a leitura das grandezas elétricas (consumo energético
              (kwh), potência real (w), fator de potência, tensão de alimentação
              da luminária (v), corrente elétrica (A) e medidas obtidas através
              do relé de telegestão;
            </li>
            <li>
              Realçar visualmente os alertas do parque de iluminação, de forma
              automática:
              <ul>
                <li>
                  Luminárias acesas: Luminárias e/ou grupos de luminárias acesos
                  indevidamente durante o dia;
                </li>
                <li>
                  Luminárias apagadas: Luminárias e/ou grupos de luminárias
                  apagadas indevidamente durante a noite;
                </li>
                <li>
                  Sobretensão: Luminárias que estejam sendo alimentadas por uma
                  tensão superior a 110% da tensão nominal da rede elétrica;
                </li>
                <li>
                  Subtensão: Luminárias que estejam sendo alimentadas por uma
                  tensão inferior a 90% da tensão nominal da rede elétrica;
                </li>
                <li>
                  Luminárias sem comunicação: Luminárias e/ou grupos de
                  luminárias que estão apresentando falha de comunicação. (obs.:
                  O tempo máximo entre a mudança de status da luminária (acesa
                  ou apagada) e atualização no mapa deverá ser de 30 minutos).
                </li>
              </ul>
            </li>

            <li>
              Cadastre novos alertas conforme os parâmetros determinados pelo
              usuário baseados nas grandezas elétricas medidas;
            </li>
            <li>
              Envie comandos para ligar e desligar luminárias, individualmente
              ou por grupo de luminárias;
            </li>
            <li>
              Envie comandos para regulação de fluxo luminoso, individualmente
              ou por grupo de luminárias;
            </li>
            <li>
              Após sincronizar com a Plataforma/Software de telegestão, as
              informações coletadas pelo relé de telegestão são exibidas dentro
              do mapeamento inteligente;
            </li>
            <li>
              Confirmação do envio e/ou recebimento de instruções (acendimento,
              leitura, gramação), registrada após a solicitação ou programação.
              (log);
            </li>
            <li>
              Tempo de carregamento da plataforma deverá ocorrer em no máximo 5
              segundos para garantir a perfomance da plataforma. (valor para
              operação de até 10.000 pontos telegeridos);
            </li>
            <li>
              Cadastro e/ou consulta dos pontos de iluminação com coordenadas
              geográficas enviadas pelos dispositivos de telegestão e/ou
              telemetria;
            </li>
            <li>
              Cadastro e/ou consulta de grupos de pontos de iluminação a partir
              do desenho de polígonos no mapa, possibilitando englobar todos os
              pontos desejados para que cada grupo possa ser nomeado
              adequadamente;
            </li>
            <li>
              Agendar perfis de horários e criação de programação
              diária/mensal/anual (Hora-ligar, Hora dimerizar e Hora-desligar);
            </li>
            <li>
              Crie grupos de acionamento e/ou dimerização de dispositivos de
              acordo com as necessidades exigidas;
            </li>
            <li>
              Registrar em Log as leituras da telemetria enviadas por cada relé
              de telemetria/telegestão: Tensão (V), Corrente (A), Energia ativa
              (kWh), Fator de Potência (FP), Potência Ativa (kW), Coordenadas
              (LAT/LONG), Nível conexão de envio e recebimento de sinal RF
              (Tx/Rx ou RSSI);
            </li>
            <li>
              Permitir a integração com outros sensores na plataforma, até mesmo
              sensores de nível para bueiros inteligentes.
            </li>
          </SC.TextList>
        </SC.TextListHolder>
        <SC.TextListHolder>
          <SC.Text3>Gestão de energia elétrica</SC.Text3>
          <SC.TextP>
            &emsp;&emsp;&emsp;Gerencie e simule o consumo de energia elétrica da
            rede municipal de iluminação pública, utilizando como base os dados
            cadastrais dos ativos ou até mesmo através da informação dos
            dispositivos de telegestão, emitindo inclusive relatórios de
            comparação entre o medido/faturado pela distribuidora de energia
            local. O relatório ainda exibe as informações de energia consumida e
            as despesas referentes a cada bairro, logradouro ou atributo
            específico cadastrado no ponto.
          </SC.TextP>
        </SC.TextListHolder>
        <SC.TextListHolder>
          <SC.Text3>Treinamento para utilização do sistema</SC.Text3>
          <SC.TextP>
            &emsp;&emsp;&emsp;Ofertamos um treinamento prático e amplo, capaz de
            capacitar os funcionários da prefeitura na utilização do sistema.
            Conduzindo de forma didática na busca e emissão de diversos
            relatórios na plataforma, exportação de dados documentais nos
            formatos de Word/Excel.
          </SC.TextP>
        </SC.TextListHolder>
        <SC.TextListHolder>
          <SC.Text3>Suporte ao sistema via WhatsApp para a prefeitura</SC.Text3>
          <SC.TextP>
            &emsp;&emsp;&emsp;Suporte 24/7 à contratante, disponibilizando
            canais no WhatsApp exclusivo para a prefeitura, com atendimento
            prático e direto com um prazo máximo de 5 minutos de resposta,
            garantimos um suporte eficiente e rápido.
          </SC.TextP>
        </SC.TextListHolder>
      </SC.ListWhite>
    </>
  );
};
